import { RefObject, useEffect } from 'react';

import useBottomSheetValues from './useBottomSheetValues';
import * as styles from '../styles';

const ANIMATION_DURATION_MS = 250;
const MINIMUM_INTERACTION_MS = 1;

function useBottomSheetEffect(ref: RefObject<HTMLDivElement|null>) {
    const { isOpen } = useBottomSheetValues();
    useEffect(() => {
        if (isOpen) {
            console.log('open');
            ref.current?.classList.remove(styles.none);
            const showTimeout = setTimeout(() => {
                ref.current?.classList.remove(styles.hide);
            }, MINIMUM_INTERACTION_MS);
            return () => clearTimeout(showTimeout);
        }
        ref.current?.classList.add(styles.hide);
        const hideTimeout = setTimeout(() => {
            ref.current?.classList.add(styles.none);
        }, ANIMATION_DURATION_MS);
        return () => clearTimeout(hideTimeout);
    }, [isOpen, ref]);
}

export default useBottomSheetEffect;
